export default function InternalRedCrossIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path
                d="M16.0662 8.99481C16.3591 8.70191 16.3591 8.22704 16.0662 7.93415C15.7733 7.64125 15.2985 7.64125 15.0056 7.93415L12.0004 10.9393L8.99518 7.93415C8.70229 7.64125 8.22742 7.64125 7.93452 7.93415C7.64163 8.22704 7.64163 8.70191 7.93452 8.99481L10.9397 12L7.93451 15.0052C7.64162 15.2981 7.64162 15.773 7.93451 16.0659C8.22741 16.3588 8.70228 16.3588 8.99517 16.0659L12.0004 13.0607L15.0056 16.0659C15.2985 16.3588 15.7734 16.3588 16.0663 16.0659C16.3591 15.773 16.3591 15.2981 16.0663 15.0052L13.061 12L16.0662 8.99481Z"
                fill="#FF5F5F"
                stroke="#FF5F5F"
                strokeWidth="1"
                strokeLinejoin="round"
            />
        </svg>
    )
}
